import React from "react";

export const FaIcon = props => {
  return (
    <i className={`fa fa-${props.icon} ${props.size ? `fa-${props.size}`: ''}`} aria-hidden="true" />
  )
};


